import {
  Link,
  Typography,
  Grid,
} from '@mui/material';
import { MsgEmailProps } from '../../../../config/interfaces';

const MsgVerify = (_props: MsgEmailProps) => {
  const { email } = _props;
  return (
    <Grid item>
      <Typography
        component="h1"
        variant="h3"
        sx={{
          mb: 4,
          textAlign: 'center',
        }}
      >
        Welcome to Cinemahive!
      </Typography>
      <Typography
        component="p"
        variant="body2"
        sx={{
          mb: 2,
          textAlign: 'justify'
        }}
      >
        If you've signed up with the email <strong>{email}</strong> at&nbsp;
        <Link target="_blank" href="https://app.cinemahive.com/" variant="caption">
          cinemahive.com
        </Link>
        , keep an eye on your inbox for an email from us. If you don't see it,
        please check your spam folder or visit our FAQ and troubleshooting page.
      </Typography>
      <Typography
        component="p"
        variant="body2"
        sx={{
          mb: 2,
          textAlign: 'justify'
        }}
      >
        Need further assistance with your account? Contact us anytime at hello@cinemahive.com.
      </Typography>
    </Grid>
  )
};

export default MsgVerify;
